"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductListContainerSkeleton = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _components = require("../../components");
var _styles = require("../../components/ProductList/styles");
var _useGetProductListMode = require("../../hooks/useGetProductListMode");
var _productListClasses = _interopRequireDefault(require("../ProductListContainer/productListClasses"));
var _jsxRuntime = require("react/jsx-runtime");
const ProductListContainerSkeleton = ({
  className,
  renderItemSkeleton,
  renderListSkeleton,
  shouldRenderItemCount,
  renderItemComponent,
  shouldRenderPagination,
  totalItemCount = 0,
  mode: modeParam = {
    type: 'LIST'
  }
}) => {
  const rootClassName = (0, _clsx.default)(_productListClasses.default.root, className);
  const {
    carousel,
    mode
  } = (0, _react.useMemo)(() => {
    const productListMode = (0, _useGetProductListMode.getMode)(modeParam, totalItemCount);
    return (0, _useGetProductListMode.getProductListModesProps)(modeParam, productListMode);
  }, [modeParam, totalItemCount]);
  if (mode === 'CAROUSEL') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselRoot, {
      className: rootClassName,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Carousel, {
        isRefreshing: true,
        carousel: carousel,
        items: [],
        renderItemComponent: renderItemComponent,
        renderItemSkeleton: renderItemSkeleton
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ListSkeleton, {
    shouldRenderItemCount: shouldRenderItemCount,
    shouldRenderPagination: shouldRenderPagination,
    renderItemSkeleton: renderItemSkeleton,
    renderListSkeleton: renderListSkeleton
  });
};
exports.ProductListContainerSkeleton = ProductListContainerSkeleton;
